/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { ReportAbuseReceiptionTypeTitles } from "../../ReportAbuseUIHelpers";

export const ReportReasonColumnFormatter = (cellContent, row, rowIndex) => {
  const { report_reason = " " } = row || {};
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <span className="text-dark d-block text-capitalize">
            {`${report_reason}`}
          </span>
        </div>
      </div>
      <> </>
    </>
  );
};
